module.exports = __webpack_public_path__ + "img/04.68277f4e.png";